<template>
  <div class="border-t border-eerie-black-400">
    <div class="mx-auto max-w-[85rem] space-y-10 px-4 py-10">
      <div class="grid justify-between gap-10 md:flex">
        <div class="order-last grid gap-6 font-segoe-bold uppercase md:order-first md:flex md:gap-10 lg:gap-16">
          <div class="space-y-4">
            <p>company</p>
            <div class="grid text-eerie-black-200">
              <template v-for="item in menuItems" :key="item.name">
                <InertiaLink
                  v-if="item.href.startsWith('/')"
                  :href="item.href"
                  class="w-fit cursor-pointer font-segoe-bold text-base text-nowrap uppercase transition-colors duration-300 hover:text-mauve-500"
                >
                  {{ item.name }}
                </InertiaLink>
                <button
                  v-else
                  type="button"
                  class="w-fit cursor-pointer text-left font-segoe-bold text-base text-nowrap uppercase transition-colors duration-300 hover:text-mauve-500"
                  @click="scrollToSection(item.href)"
                >
                  {{ item.name }}
                </button>
              </template>
            </div>
          </div>
          <div class="space-y-4">
            <p>legal</p>
            <div class="grid text-eerie-black-200">
              <InertiaLink
                v-for="item in legalItems"
                :key="item.name"
                :href="item.href"
                class="w-fit cursor-pointer font-segoe-bold text-base whitespace-nowrap uppercase transition-colors duration-300 hover:text-mauve-500"
                @click="handleLegalClick(item.href, $event)"
              >
                {{ item.name }}
              </InertiaLink>
            </div>
          </div>
          <div class="space-y-4">
            <p>contact</p>
            <div class="grid gap-2 text-eerie-black-200">
              <a
                href="mailto:hello@vibeteams.ai"
                class="flex w-fit cursor-pointer items-center gap-2 font-segoe-bold text-base lowercase transition-colors duration-300 hover:text-mauve-500"
              >
                <Mail class="h-4 w-4" />
                hello@vibeteams.ai
              </a>
            </div>
          </div>
        </div>
        <div class="order-first max-w-sm space-y-4 text-eerie-black-200 md:order-last">
          <InertiaLink href="/" class="grid w-fit">
            <img src="@images/logo/vibeteams-logo-secondary.svg" alt="Vibe Teams Logo" class="h-10" loading="lazy" />
          </InertiaLink>

          <p class="text-sm">
            Assemble AI specialist teams that debate, challenge assumptions, and refine solutions together—delivering perspectives no single AI can
            provide.
          </p>
        </div>
      </div>
      <hr class="w-full border-eerie-black-400" />
      <p class="text-center text-eerie-black-200">© 2025 VibeTeams. Built with ❤️ for collaborative AI.</p>
    </div>
  </div>
</template>

<script lang="ts">
import { Link } from '@inertiajs/vue3';
import { Mail } from 'lucide-vue-next';
export default {
  components: {
    InertiaLink: Link,
    Mail,
  },
  data() {
    return {
      menuItems: [
        { name: 'About', href: '#aboutUs' },
        { name: 'How it Works', href: '#howItWorks' },
        { name: 'Pricing', href: '#pricing' },
      ],
      legalItems: [
        { name: 'Terms of Service', href: '/terms-of-service' },
        { name: 'Privacy Policy', href: '/privacy-policy' },
        { name: 'Refund Policy', href: '/refund-policy' },
      ],
    };
  },
  methods: {
    scrollToSection(sectionId: string) {
      // Remove the # from the sectionId if it exists
      const targetId = sectionId.startsWith('#') ? sectionId.slice(1) : sectionId;
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const navbarHeight = 100; // Height of the fixed navbar, adjust lang as needed
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      } else {
        // If section doesn't exist on current page, navigate to landing page
        this.$inertia.visit('/', {
          preserveScroll: false,
          onSuccess: () => {
            // Wait for DOM to be ready, then scroll to section
            this.$nextTick(() => {
              requestAnimationFrame(() => {
                const target = document.getElementById(targetId);
                if (target) {
                  const navbarHeight = 100;
                  const elementPosition = target.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                  });
                }
              });
            });
          },
        });
      }
    },
    handleLegalClick(href: string, event: Event) {
      event.preventDefault();

      // Check if we're already on this page
      const currentPath = window.location.pathname;
      if (currentPath === href) {
        // Same page - scroll to top
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        // Different page - navigate with Inertia
        this.$inertia.visit(href);
      }
    },
  },
};
</script>
